export const generateStreamCIDKey = ({ orgId, streamId, id }) => {
  if (streamId) {
    return [orgId, streamId].join('/');
  }

  return [orgId, id].join('/');
};
